module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main download",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "home-part download"
  }, [_c('div', {
    staticClass: "home-intro"
  }, [_c('img', {
    staticClass: "multi-device",
    attrs: {
      "src": require("../assets/images/20180102/downloadpic@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title"
  }, [_vm._v(_vm._s(_vm.$t('d-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "download-qrcode"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('sub-intro1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sub-intro2')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/20180419/Crait_download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-download"
  }, [_c('a', {
    staticClass: "download-ios cur decoration",
    attrs: {
      "href": "https://itunes.apple.com/app/id1227620003"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-android cur decoration",
    attrs: {
      "href": "https://www.craitapp.com/download/crait.apk"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-google cur decoration",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.secrat.cloud"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-pc cur decoration",
    attrs: {
      "href": "https://fs.craitapp.com/download/crait-setup.exe"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d60cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download.vue
// module id = 257
// module chunks = 1